import React from 'react';
import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import { TListingClient } from 'types/TListing';
import FranchiseDealerItemsLazy from './components/FranchiseDealerItems';

export type TFranchiseDealersItemsProps = {
  appState: {
    listing: TListingClient;
  };
  environment: any;
};

const FranchiseDealersItemsApp = ({ appState, environment }: TFranchiseDealersItemsProps) => {
  const { listing } = appState;
  return (
    <EnvironmentProvider value={environment}>
      <FranchiseDealerItemsLazy listing={listing} />
    </EnvironmentProvider>
  );
};

export default FranchiseDealersItemsApp;
